import React, { useState } from "react";
import axios from "axios";
import { FaSquareXTwitter } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa6";
import { FaFacebookSquare } from "react-icons/fa";
export default function ContactPage() {
  const [form, setForm] = useState({
    role: "Doctor",
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const { data } = await axios.post(
        "https://api.clinicalaiassistance.com/api/contact/contactus",
        form,
      );

      if (data.success) {
        alert("Message sent successfully");

        setForm({
          role: "Doctor",
          name: "",
          email: "",
          message: "",
        });
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error(error);
      alert("Failed to send");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-zinc-900 transition-colors p-4 md:p-10">
      <div className="mt-8 p-2 sm:p-4 md:p-10">
        <div className="max-w-6xl mx-auto bg-blue-700 rounded-[2rem] shadow-2xl overflow-hidden grid grid-cols-1 lg:grid-cols-2 gap-8 p-6 md:p-16">
          {/* LEFT SECTION */}
          <div className="text-white flex flex-col justify-center">
            <h1 className="text-4xl sm:text-5xl md:text-7xl font-bold mb-6 leading-tight">
              Get in touch
            </h1>

            <p className="text-base sm:text-lg md:text-2xl text-blue-100 leading-relaxed max-w-xl">
              Interested in supercharging your health services? We’re here to
              help. Fill out the form or contact us directly.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-10 text-base sm:text-lg">
              <div className="min-w-0">
                <h3 className="font-bold">PHONE</h3>

                <a
                  href="tel:+447393165375"
                  className="text-blue-100 mt-2 break-words block hover:text-white underline transition"
                >
                  +44 7393165375
                </a>
              </div>

              <div className="min-w-0">
                <h3 className="font-bold">EMAIL</h3>

                <a
                  href="mailto:info@clinicalaiassistance.com"
                  className="text-blue-100 mt-2 break-all block hover:text-white underline transition"
                >
                  info@clinicalaiassistance.com
                </a>
              </div>
            </div>

            <div className="mt-10">
              <h3 className="font-bold text-lg sm:text-xl mb-3">SOCIALS</h3>

              <div className="flex gap-4 text-xl sm:text-2xl flex-wrap">
                <a
                  href="https://x.com/_Clinical_AI_/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition"
                >
                  <FaSquareXTwitter />
                </a>

                <a
                  href="https://www.linkedin.com/company/clinical-ai-assistance"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition"
                >
                  <FaLinkedin />
                </a>

                <a
                  href="https://www.facebook.com/ClinicalAIAssistance"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition"
                >
                  <FaFacebookSquare />
                </a>
              </div>
            </div>
          </div>

          {/* FORM SECTION */}
          <form
            onSubmit={handleSubmit}
            className="bg-white dark:bg-zinc-800 rounded-2xl p-6 md:p-8 shadow-xl"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="text-sm dark:text-white">I am a</label>

                <select
                  name="role"
                  value={form.role}
                  onChange={handleChange}
                  required
                  className="w-full mt-2 p-3 rounded-xl border dark:bg-zinc-700 dark:text-white"
                >
                  <option value="Doctor">Doctor</option>
                  <option value="Hospital">Hospital</option>
                  <option value="Patient">Patient</option>
                </select>
              </div>

              <div>
                <label className="text-sm dark:text-white">Full name</label>

                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                  placeholder="Example Doe"
                  className="w-full mt-2 p-3 rounded-xl border dark:bg-zinc-700 dark:text-white"
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="text-sm dark:text-white">Email address</label>

              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                placeholder="example@example.com"
                className="w-full mt-2 p-3 rounded-xl border dark:bg-zinc-700 dark:text-white"
              />
            </div>

            <div>
              <label className="text-sm dark:text-white">Message</label>

              <textarea
                name="message"
                value={form.message}
                onChange={handleChange}
                required
                rows={6}
                placeholder="Your message..."
                className="w-full mt-2 p-3 rounded-xl border dark:bg-zinc-700 dark:text-white resize-none"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className={`w-full mt-6 py-4 rounded-full text-lg font-semibold transition ${
                loading
                  ? "bg-gray-400 cursor-not-allowed text-white"
                  : "bg-slate-950 text-white hover:opacity-90"
              }`}
            >
              {loading ? "Sending..." : "Send Message"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
